export const allFirstLettersToUpperCase = (upperCaseString: string) => {
  return String(upperCaseString)
    .toLowerCase()
    .replace(/(?:^|\s|[-"'([{])+\S/g, (match) => match.toUpperCase());
};

export const firstLetterToUpperCase = (str?: string) =>
  str ? str.charAt(0).toUpperCase() + str.slice(1) : '';

export const removeTextBetwweenParentheses = (text: string) => {
  return text ? text.replace(/\(([^)]+)\)/g, '') : '';
};

export const getTextBetweenParentheses = (text: string) => {
  const matches = text.match(/\(([^)]+)\)/g);
  return matches ? matches[0].replace(/([()])/g, '') : '';
};

export const removePercentile = (text: string) => {
  return text ? text.replace(/%/, '') : '';
};
